import { OriginInfo } from "@/types";
import getSiteFromDomain from "@/vue/planning/logic/getSiteFromDomain";

export type TrainStationCountryCode = "UK" | "FR" | "NL" | "BE"

export const trainStationsByCountry: Record<TrainStationCountryCode, Array<[string, OriginInfo]>> = {
	// We don't use anymore property "name", we use the content translation from ssr (ie planning_traintimeline_station_PLY)
	UK: [
		["STP", { name: "London Saint Pancras" }] 
	],
	FR: [
		// ["PLY", { name: "Paris - Gare de Lyon" }],
		["PAZ", { name: "Paris - Gare d'Austerlitz" }],
	],
	NL: [
		["AMS", { name: "Amsterdam Centraal" }],
		["RTM", { name: "Rotterdam Centraal" }],
	],
	BE: [
		["ANR", { name: "Antwerp" }],
		["BRU", { name: "Brussels" }],
	],
}

export const trainStationCodeMapByWebsiteDomain: Record<string, Map<string, OriginInfo>> = {
	"www.uk.travelski.com": new Map<string, OriginInfo>(trainStationsByCountry.UK),
	"www.travelski.com": new Map<string, OriginInfo>([...trainStationsByCountry.FR, ...trainStationsByCountry.BE]),
	"www.nl.travelski.com": new Map<string, OriginInfo>([...trainStationsByCountry.NL, ...trainStationsByCountry.BE]),
	"www.befr.yoonly.eu": new Map<string, OriginInfo>([...trainStationsByCountry.BE]),
	"www.benl.yoonly.eu": new Map<string, OriginInfo>([...trainStationsByCountry.NL, ...trainStationsByCountry.BE]),
	"www.nl.yoonly.eu": new Map<string, OriginInfo>([...trainStationsByCountry.NL, ...trainStationsByCountry.BE]),
	"cse.travelski.com": new Map<string, OriginInfo>([...trainStationsByCountry.FR, ...trainStationsByCountry.BE]),
}
const country = getSiteFromDomain(window.location.hostname);
export const trainStationCodeMap = new Map<string, OriginInfo>(trainStationCodeMapByWebsiteDomain[country]);

// export const trainStationCodeMap = new Map<string, OriginInfo>(Object.values(trainStationsByCountry).flat())
